import { render, staticRenderFns } from "./DevCardKD5.vue?vue&type=template&id=3f84125b&scoped=true"
import script from "./DevCardKD5.vue?vue&type=script&lang=js"
export * from "./DevCardKD5.vue?vue&type=script&lang=js"
import style0 from "./DevCardKD5.vue?vue&type=style&index=0&id=3f84125b&prod&lang=css"
import style1 from "./DevCardKD5.vue?vue&type=style&index=1&id=3f84125b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f84125b",
  null
  
)

export default component.exports